export default __webpack_public_path__ + "static/media/number-shine-8.bed52bf9.svg";